import Vue from 'vue'

// 节流
Vue.directive('throttle', require('./throttle').default)
// 防抖
Vue.directive('debounce', require('./debounce').default)
